/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Activity_Unknowndate1Inputs */

const id_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal tidak diketahui`)
};

const ms_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh tidak diketahui`)
};

const da_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukendt dato`)
};

const de_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekanntes Datum`)
};

const en_us2_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown date`)
};

const es_es2_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha desconocida`)
};

const es_mx2_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha desconocida`)
};

const fil_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi kilalang petsa`)
};

const fr_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date inconnue`)
};

const it_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data sconosciuta`)
};

const hu_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismeretlen dátum`)
};

const nl_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekende datum`)
};

const no_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukjent dato`)
};

const pl_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieznana data`)
};

const pt_br2_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data desconhecida`)
};

const pt_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data desconhecida`)
};

const ro_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dată necunoscută`)
};

const fi_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuntematon päivämäärä`)
};

const sv_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okänt datum`)
};

const vi_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày không xác định`)
};

const tr_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen tarih`)
};

const cs_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámé datum`)
};

const bg_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непозната дата`)
};

const ru_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестная дата`)
};

const uk_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невідома дата`)
};

const ar_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ غير معروف`)
};

const hi_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात तारीख़`)
};

const th_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่ไม่ทราบ`)
};

const ja_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不明な日付`)
};

const zh_cn2_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期未知`)
};

const zh_hant1_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期未知`)
};

const ko_profile_activity_unknowndate1 = /** @type {(inputs: Profile_Activity_Unknowndate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알 수 없는 날짜`)
};

/**
* | output |
* | --- |
* | "Unknown date" |
*
* @param {Profile_Activity_Unknowndate1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_activity_unknowndate1 = /** @type {((inputs?: Profile_Activity_Unknowndate1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Activity_Unknowndate1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_activity_unknowndate1(inputs)
	if (locale === "ms") return ms_profile_activity_unknowndate1(inputs)
	if (locale === "da") return da_profile_activity_unknowndate1(inputs)
	if (locale === "de") return de_profile_activity_unknowndate1(inputs)
	if (locale === "en-US") return en_us2_profile_activity_unknowndate1(inputs)
	if (locale === "es-ES") return es_es2_profile_activity_unknowndate1(inputs)
	if (locale === "es-MX") return es_mx2_profile_activity_unknowndate1(inputs)
	if (locale === "fil") return fil_profile_activity_unknowndate1(inputs)
	if (locale === "fr") return fr_profile_activity_unknowndate1(inputs)
	if (locale === "it") return it_profile_activity_unknowndate1(inputs)
	if (locale === "hu") return hu_profile_activity_unknowndate1(inputs)
	if (locale === "nl") return nl_profile_activity_unknowndate1(inputs)
	if (locale === "no") return no_profile_activity_unknowndate1(inputs)
	if (locale === "pl") return pl_profile_activity_unknowndate1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_activity_unknowndate1(inputs)
	if (locale === "pt") return pt_profile_activity_unknowndate1(inputs)
	if (locale === "ro") return ro_profile_activity_unknowndate1(inputs)
	if (locale === "fi") return fi_profile_activity_unknowndate1(inputs)
	if (locale === "sv") return sv_profile_activity_unknowndate1(inputs)
	if (locale === "vi") return vi_profile_activity_unknowndate1(inputs)
	if (locale === "tr") return tr_profile_activity_unknowndate1(inputs)
	if (locale === "cs") return cs_profile_activity_unknowndate1(inputs)
	if (locale === "bg") return bg_profile_activity_unknowndate1(inputs)
	if (locale === "ru") return ru_profile_activity_unknowndate1(inputs)
	if (locale === "uk") return uk_profile_activity_unknowndate1(inputs)
	if (locale === "ar") return ar_profile_activity_unknowndate1(inputs)
	if (locale === "hi") return hi_profile_activity_unknowndate1(inputs)
	if (locale === "th") return th_profile_activity_unknowndate1(inputs)
	if (locale === "ja") return ja_profile_activity_unknowndate1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_activity_unknowndate1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_activity_unknowndate1(inputs)
	return ko_profile_activity_unknowndate1(inputs)
});
export { profile_activity_unknowndate1 as "profile.activity.unknownDate" }